<template>
  <div>
    <el-button @click="goToPreview"
      ><i class="fas fa-chevron-left mr-1"></i>
      Preview</el-button
    >
    <el-button
      type="primary"
      v-if="files && files.length"
      :loading="loadingZip"
      @click="zip()"
      ><i class="fas fa-download mr-1"></i> Download the
      Code</el-button
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-project-download-actions',

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      project: 'project/project',
      loadingZip: 'project/loadingZip',
      files: 'project/files',
    }),
  },

  methods: {
    ...mapActions({
      zip: 'project/zip',
    }),

    goToPreview() {
      this.$router.push({
        name: 'project-preview',
        params: {
          projectId: this.project.id,
        },
      });
    },
  },
};
</script>

<style></style>
